var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFragmentDownloadTemplate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2955_663)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H9.1V5.25H14V6.05493C14.3283 6.01863 14.662 6 15 6C19.9706 6 24 10.0294 24 15C24 19.9706 19.9706 24 15 24C11.0813 24 7.74763 21.4956 6.51212 18H0V0ZM9.8 0.75V4.5H13.3L9.8 0.75ZM23 15C23 19.4183 19.4183 23 15 23C10.5817 23 7 19.4183 7 15C7 10.5817 10.5817 7 15 7C19.4183 7 23 10.5817 23 15Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9167 9.75C10.2723 9.75 9.75 10.2723 9.75 10.9167L9.75 19.0833C9.75 19.7277 10.2723 20.25 10.9167 20.25H19.0833C19.7277 20.25 20.25 19.7277 20.25 19.0833V10.9167C20.25 10.2723 19.7277 9.75 19.0833 9.75L10.9167 9.75ZM15 16.75L12.6667 14.4167H14.4167V11.5C14.4167 10.9167 14.4167 10.9167 15 10.9167C15.5833 10.9167 15.5833 10.9167 15.5833 11.5V14.4167H17.3333L15 16.75ZM10.9167 18.5C10.9167 18.8222 11.1778 19.0833 11.5 19.0833H18.5C18.8222 19.0833 19.0833 18.8222 19.0833 18.5V17.3333H17.9167V17.625C17.9167 17.7861 17.7861 17.9167 17.625 17.9167H12.375C12.2139 17.9167 12.0833 17.7861 12.0833 17.625V17.3333H10.9167V18.5Z",
    fill: "current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2955_663"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFragmentDownloadTemplate);
export default __webpack_public_path__ + "static/media/FragmentDownloadTemplate.380fe27c40c73ea129337f6ed5b05408.svg";
export { ForwardRef as ReactComponent };